import React from 'react'
import { Row, Col } from 'react-bootstrap'

import ExecutiveOfficer from './ExecutiveOfficer'

import COChadGuillerault from './COChadGuillerault'
import COBJeremyRooks from './COBJeremyRooks'

const CrewSection = () => (
    <>
    <COChadGuillerault />
    <ExecutiveOfficer />
    
    <COBJeremyRooks />
</>
)

export default CrewSection